import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../store/database';

export default function GatewayPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const session = useStore(s => s.session);
  const getMember = useStore(s => s.getMember);
  const getPendingLegal = useStore(s => s.getPendingLegal);
  const isAdmin = useStore(s => s.isAdmin);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    if (!session) { navigate('/login'); return; }

    // Admin with no member profile → go to admin
    if (isAdmin() && !session.member_id) {
      setMsg(t('gateway.accessGranted'));
      setTimeout(() => navigate('/admin'), 2000);
      return;
    }

    const member = getMember();
    if (!member) { navigate('/login'); return; }

    // Check status
    if (member.status === 'waitlist' || member.status === 'paused' || member.status === 'revoked') {
      setMsg(t('gateway.statusBlocked'));
      setTimeout(() => navigate('/account'), 3000);
      return;
    }

    // Check legal
    const pending = getPendingLegal(member.id);
    if (pending.length > 0) {
      setMsg(t('gateway.legalRequired'));
      setTimeout(() => navigate('/legal'), 2000);
      return;
    }

    // All good
    setMsg(t('gateway.accessGranted'));
    setTimeout(() => navigate('/house'), 2500);
  }, [session]);

  return (
    <div className="min-h-dvh bg-charcoal flex flex-col items-center justify-center px-6">
      <div className="text-center space-y-6">
        <h1 className="font-serif text-4xl text-ivory tracking-widest-xl">AH</h1>
        <div className="w-12 h-px bg-gold mx-auto" />
        <p className="text-[11px] tracking-widest-xl uppercase text-ivory/60 font-sans animate-pulse">{msg || t('gateway.redirecting')}</p>
      </div>
    </div>
  );
}
